<mat-form-field class="example-chip-list" appearance="fill">
  <mat-label>Tags</mat-label>
  <mat-chip-list #chipList aria-label="Tags">
    <mat-chip
      *ngFor="let tag of tags"
      (removed)="remove(tag)">
      {{tag.name}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <input
      placeholder="Find tag..."
      #tagInput
      [formControl]="fruitCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
      {{fruit.name}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
<br>
<!--<button (click)="test()">test</button>-->
<div class="btn-bottom-area">
  <button (click)="save()" mat-raised-button color="primary">Save</button>
  <button (click)="cancel()" mat-raised-button color="warn">Cancel</button>
</div>
<!--<button style="width:100%;" (click)="save()" mat-raised-button color="warn">OK</button>-->
